import React from 'react';
import DataDrivenGuidePage from '../../components/guides/DataDrivenGuidePage';

const EvMotorSizingGuidePage = () => <DataDrivenGuidePage slug="guide-ev-motor-sizing" />;

export default EvMotorSizingGuidePage;
